module.exports = "/fonts/Arial.ttf?124a965ffc59a680c2c20c69c2984032";